
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strains/lists/[...slug]",
      function () {
        return require("private-next-pages/strains/lists/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strains/lists/[...slug]"])
      });
    }
  